import { render, staticRenderFns } from "./MirrorShadow.vue?vue&type=template&id=1daa4c42&scoped=true"
import script from "./MirrorShadow.vue?vue&type=script&lang=js"
export * from "./MirrorShadow.vue?vue&type=script&lang=js"
import style0 from "./MirrorShadow.vue?vue&type=style&index=0&id=1daa4c42&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daa4c42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1daa4c42')) {
      api.createRecord('1daa4c42', component.options)
    } else {
      api.reload('1daa4c42', component.options)
    }
    module.hot.accept("./MirrorShadow.vue?vue&type=template&id=1daa4c42&scoped=true", function () {
      api.rerender('1daa4c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/MirrorShadow.vue"
export default component.exports